var _templateObject = _taggedTemplateLiteralLoose(['background-color: ', '; color: #FFFFFF'], ['background-color: ', '; color: #FFFFFF']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
import { css } from 'emotion';

import { RXBlockStatus } from "./RXBlock";
import { RXModal, RXModalSize, RXModalColor } from './RXModal';

var logdown = require('logdown');
var console = logdown('rx-core-dialog', { prefixColor: '#d84315' });

export var RXDialog = function (_Component) {
    _inherits(RXDialog, _Component);

    function RXDialog(props) {
        _classCallCheck(this, RXDialog);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.show = function (originData) {
            console.log('try without waitLoad');
            var data = {};
            if (originData) {
                data = originData;
            }
            _this.setState({ show: true, data: data });
        };

        _this.onToggle = function () {
            console.log('in ontoggle');
            _this.setState({ show: false });
        };

        _this.onButtonPress = function (event, value) {
            console.log('in onButtonPress with ' + value);
            if (_this.props.onSubmit) {
                _this.setState({ blockStatus: RXBlockStatus.LOAD, buttonsDisabled: true });
                new Promise(function (success, fail) {
                    _this.props.onSubmit(_this.state.data, value, success, fail);
                }).then(function (data) {
                    _this.setState({ blockStatus: RXBlockStatus.SUCCESS, buttonsDisabled: false, show: false });
                }).catch(function (error) {
                    _this.setState({ blockStatus: RXBlockStatus.ERROR });
                });
            }
        };

        _this.state = {
            blockStatus: RXBlockStatus.HIDE,
            blockColor: _this.props.blockColor,
            blockMessage: "",
            show: false,
            size: _this.props.size,
            title: _this.props.title,
            buttons: _this.props.buttons,
            headerColor: _this.props.headerColor,
            buttonsDisabled: false
        };

        _this.headerClass = css(_templateObject, _this.state.buttonColor);

        return _this;
    }

    RXDialog.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            RXModal,
            {
                show: this.state.show,
                size: this.state.size,
                toggle: this.onToggle,
                title: this.state.title
                // onLoad={this.onLoad}
                , blockStatus: this.state.blockStatus,
                blockColor: this.state.blockColor,
                headerColor: this.state.headerColor,
                footer: React.createElement(
                    Container,
                    null,
                    React.createElement(
                        Row,
                        null,
                        this.state.buttons.map(function (button, index) {
                            return React.createElement(
                                Col,
                                { key: index },
                                React.createElement(
                                    Button,
                                    { block: true, className: _this2.headerClass, disabled: _this2.state.buttonsDisabled, color: button.color, size: 'lg', onClick: function onClick(event) {
                                            _this2.onButtonPress(event, button.value);
                                        } },
                                    button.title
                                )
                            );
                        })
                    )
                )
            },
            this.props.children
        );
    };

    return RXDialog;
}(Component);

RXDialog.defaultProps = {
    size: RXModalSize.NORMAL,
    title: "Default Dialog Titlez",
    headerColor: RXModalColor.PRIMARY,
    blockColor: RXModalColor.PRIMARY,
    buttons: [{ title: "Abort", value: "ABORT", color: "primary" }]

    // module.exports = {
    //     RXDialog: RXDialog
    // }

};